import React from 'react';

const Checked = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6 3H18C19.654 3 21 4.346 21 6V18C21 19.654 19.654 21 18 21H6C4.346 21 3 19.654 3 18V6C3 4.346 4.346 3 6 3ZM11.4209 13.3634L15.2049 8.39443C15.5379 7.95543 16.1659 7.86943 16.6059 8.20443C17.0459 8.53943 17.1309 9.16543 16.7959 9.60543L12.2269 15.6054C12.0399 15.8524 11.7479 15.9984 11.4389 15.9994H11.4319C11.1239 15.9994 10.8339 15.8584 10.6439 15.6164L8.2129 12.5094C7.8719 12.0754 7.9489 11.4464 8.3839 11.1064C8.8189 10.7654 9.4469 10.8414 9.7879 11.2774L11.4209 13.3634Z"
    fill="black"
  />
);

const Unchecked = () => (
  <path
    d="M6 4H18C19.1017 4 20 4.89828 20 6V18C20 19.1017 19.1017 20 18 20H6C4.89828 20 4 19.1017 4 18V6C4 4.89828 4.89828 4 6 4Z"
    stroke="#ABAAAB"
    strokeWidth="2"
  />
);

export type CheckboxIconProps = {
  checked: boolean;
  className?: string;
};

const CheckboxIcon = ({ checked, className }: CheckboxIconProps) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {checked ? <Checked /> : <Unchecked />}
  </svg>
);

export default CheckboxIcon;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/RefundSelectionPage/CheckboxIcon.tsx